import { render, staticRenderFns } from "./add-supplement-product.vue?vue&type=template&id=5be8dc9e&scoped=true"
import script from "./add-supplement-product.vue?vue&type=script&lang=js"
export * from "./add-supplement-product.vue?vue&type=script&lang=js"
import style0 from "./add-supplement-product.vue?vue&type=style&index=0&id=5be8dc9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be8dc9e",
  null
  
)

export default component.exports